import { httpClient, type Cursor, type ID } from '#shared'
import { wsClient } from '#shared/api/ws-client'
import type { GetMessagesResponse } from '../model/get-messages-response'

export interface GetMessagesOptions {
  count?: number
  after?: Cursor | null
  before?: Cursor | null
  search?: string | null
}

export async function getMessages(chatId: ID, { count = 20, after, before, search }: GetMessagesOptions = {}) {
  const path = `chats/${chatId}/messages`

  const searchParams = new URLSearchParams([['count', count.toString()]])

  if (wsClient.meta?.initializedAt) {
    searchParams.set('olderThan', wsClient.meta.initializedAt.toISOString())
  }

  if (after) searchParams.set('after', after.toString())
  if (before) searchParams.set('before', before.toString())
  if (search) searchParams.set('query', search)

  const requestUrl = `${path}?${searchParams.toString()}`

  const response = await httpClient.get<GetMessagesResponse>(requestUrl)
  const responseBody = await response.json()

  return responseBody
}
